import { useQuery } from '@tanstack/react-query'
import { readBlockConnectorCandidates as readBlockConnectorCandidatesRequest } from './requests/read'
import { type BlockConnectorCandidatesResponse } from './types'
import { readBlockConnectorCandidates } from '.'

type UseReadBlockConnectorCandidatesParams = {
  blockId: string
  workspaceUuid: string
  enabled?: boolean
  allBlocks?: boolean
}

type UseReadBlockConnectorCandidatesOptions<
  T = BlockConnectorCandidatesResponse,
> = UseReadBlockConnectorCandidatesParams & {
  select?: (data: BlockConnectorCandidatesResponse) => T
}

export const useReadBlockConnectorCandidates = <
  T = BlockConnectorCandidatesResponse,
>({
  blockId,
  workspaceUuid,
  enabled,
  allBlocks,
  select,
}: UseReadBlockConnectorCandidatesOptions<T>) => {
  return useQuery({
    enabled,
    queryKey: readBlockConnectorCandidates.queryKey({
      workspaceUuid,
      resourceId: blockId,
      queryParams: {
        all_blocks: allBlocks,
      },
    }),
    queryFn: () =>
      readBlockConnectorCandidatesRequest({
        params: {
          path: {
            block_id: blockId,
            workspace_id: workspaceUuid,
          },
          query: {
            all_blocks: allBlocks,
          },
        },
      }),
    select,
  })
}
